export default "__VITE_ASSET__09e1abf4__"